<template>
  <div id="app" v-if="pass">
    <div class="containerv2">
      <HeadView />
      <router-view />
      <FootView />
    </div>
  </div>
</template>

<script>
import HeadView from "common/head/HeadView";
import FootView from "common/foot/FootView";
import { number } from "echarts";
export default {
  name: "App",
  components: {
    HeadView,
    FootView,
  },
  data() {
    return {
      pass: false,
    };
  },
  created() {
    var url = location.href.toLocaleLowerCase();
    if (url.indexOf("/error") > -1 || url.indexOf("/login") > -1) {
      this.pass = true;
    } else {
      this.$com.loadOrg().then((org) => {
        document.title = org.orgName;
        //免登录适配 lp 20240730
        var params = this.$com.getParams();
        if (params.token) {
          this.$com.setToken(params.token);
          //this.$message({ type: "success", message: member.tel+" 登录成功！" });
          //删除链接中的token参数
          // 1. 获取当前URL的查询参数
          const urlParams = new URLSearchParams(window.location.search);
          // 2. 删除特定参数
          urlParams.delete('token');
          // 3. 构建新的URL
          const newUrl = window.location.origin + window.location.pathname + '?' + urlParams.toString();
          // 4. 重定向到新的URL
          window.location.href = newUrl;
        }

        // if (url.indexOf("/auth") > -1) {
        //   var params = this.$com.getParams();
        //   if (params.token) {
        //     this.$com.setToken(params.token);
        //   }
        // }

        var member = this.$com.getMember();
        //console.log(member)
        if (member) {
          if (Math.floor(new Date().getTime() / 1000) > member.exp) {
            this.$com.delToken();
          }
        }

        //自动IP登录
        var org = this.$com.getOrg();
        if (org.iplogin == '1' && !this.$com.isLogin()) {
          this.$bti.IpLogin({ schoolId: org.id }).then((res) => {
            if (res.code != 1) {
              console.log(res.info);
            }
            this.$com.setToken(res.data);
            this.pass = true;
          });
        }
        else
          this.pass = true;
      });
    }
  },
};
</script>

<style lang="css" scoped></style>



// WEBPACK FOOTER //
// src/App.vue